import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BaseModalComponent } from '../../../../ui-components/modal/base-modal-component';
import { SharedModule } from '../../../../ui-components/shared.module';

/**
 * « À propos de Willy » (P5.1.1), en feuille du bas : ce qu'il fait, qu'il peut
 * se tromper, et comment signaler une réponse. Garde l'API d'une modale
 * (`isOpen`, `onModalClosed`) : l'en-tête du chat ne change pas.
 */
@Component({
  selector: 'vw-ai-chatbot-info-modal',
  imports: [SharedModule, TranslatePipe],
  templateUrl: './ai-chatbot-info-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AiChatbotInfoModalComponent extends BaseModalComponent {
  constructor() {
    super();
  }
}
